var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg3DPanelIcon = function Svg3DPanelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 52,
    fill: "none",
    viewBox: "0 0 55 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD0FF",
    d: "m44.03 40.291-17.034-9.463-17.412 9.463 17.412 10.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4FE",
    d: "m26.996 30.45-.378-19.305-17.034 9.842V40.29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    d: "M44.408 40.291V20.608l-17.412-9.841v20.061z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    d: "M26.81 10.767 9.585 20.816V40.31l17.227 10.466L44.408 40.31V20.816z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    d: "M26.81 10.906v19.773l17.597 9.725M26.81 30.68 9.678 40.31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "M26.97.572a.5.5 0 0 0-.706 0l-3.182 3.182a.5.5 0 1 0 .707.707l2.828-2.828 2.829 2.828a.5.5 0 1 0 .707-.707zm.147 10.952V.926h-1v10.598zM.02 45.237a.5.5 0 0 0 .34.62l4.318 1.265a.5.5 0 0 0 .281-.96L1.12 45.04l1.124-3.84a.5.5 0 0 0-.96-.28zm9.538-5.385L.26 44.94l.48.877 9.298-5.086zM54.185 45.237a.5.5 0 0 1-.339.62l-4.319 1.265a.5.5 0 0 1-.28-.96l3.838-1.123-1.123-3.84a.5.5 0 1 1 .96-.28zm-9.537-5.385 9.298 5.087-.48.877-9.298-5.086z"
  })));
};
export default Svg3DPanelIcon;